import {every, first, isArray, isEmpty, isEqual, isObject, isString, keys, omit, values} from 'underscore'
import BaseFormErrorsMixin from './base-form-errors.mixin'
import BaseFormFieldChecksMixin from './base-form-fields.mixin'

const formData = () => ({})

/**
 * @mixin
 */
export default {
    mixins: [BaseFormErrorsMixin, BaseFormFieldChecksMixin],
    props: {
        /**
         * The item to be passed to the form.  This is merged into `formData`
         */
        item: {
            type: [Array, Object],
            default: formData
        }
    },
    data: () => ({
        formData: formData(),
        autofillData: {},
        formValid: false
    }),
    computed: {
        itemFormatted () {
            return this.item
        },
        canSubmit () {
            const vm = this
            return (vm.hasFormDataChanged && vm.formValid) || vm.hasAutofillActive
        },
        hasFormDataChanged () {
            const vm = this
            const formData = vm.cleanFormData(vm.formData)
            const item = vm.cleanFormData(vm.itemFormatted)
            const initFormData = vm.cleanFormData(vm.initFormData())

            return !isEqual(formData, item)
                && !isEqual(formData, initFormData)
        },
        hasAutofillActive () {
            const autofillValues = values(this.autofillData)

            if (!isEmpty(autofillValues)) {
                return every(autofillValues, (val) => val)
            }

            return false
        }
    },
    methods: {
        cleanFormData: (data) => omit(data, (val) => {
            return isArray(val) || isObject(val)
                ? isEmpty(val)
                : (val === null || val === undefined)
        }),
        handleAutofill (key, val) {
            this.autofillData = {...this.autofillData, [key]: val}
            /**
             * Emit form:autofilled event
             * @event form:autofilled
             * @type {boolean}
             */
            this.$emit('form:autofilled', this.autofillData)
        },
        handleFormDataChange () {
            /**
             * Emit form-data:change event
             * @event form-data:change
             * @type {boolean}
             */
            this.$emit('form-data:change', this.hasFormDataChanged)
        },
        handleSubmit () {
            if (this.canSubmit) {
                /**
                 * Emit submit event
                 * @event submit
                 * @type {Object}
                 */
                this.$emit('submit', this.formData)
            }
        },
        initFormData: formData,
        setFieldData (prop, val, dataKey) {
            const vm = this
            const nestedKey = dataKey
                ? isString(dataKey) ? dataKey : 'data'
                : false

            const formData = nestedKey
                ? vm.formData[nestedKey]
                : vm.formData

            let data = isObject(prop) ? prop : {[prop]: val}
            let key

            if (vm.hasFormErrors && (key = first(keys(data)))) {
                vm.clearFieldErrors(key)
            }

            if (isArray(data[prop]) || isObject(data[prop])) {
                data[prop] = isEmpty(data[prop]) ? undefined : data[prop]
            }

            data = Object.assign(formData, data)

            if (nestedKey) {
                this.$set(this.formData, nestedKey, data)
            } else {
                this.formData = data
            }

            /**
             * Emit change event.
             * @event change
             * @type {object}
             */
            this.$emit('change', data)
        },
        setFormData () {
            const vm = this
            vm.formData = {...vm.formData, ...vm.itemFormatted}
        },
        resetFormData () {
            const vm = this
            vm.formData = vm.initFormData()
        }
    },
    watch: {
        item () {
            this.setFormData()
        },
        hasFormDataChanged (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.handleFormDataChange()
            }
        }
    },
    created () {
        this.setFormData()
    },
    destroyed () {
        this.resetFormData()
    }
}
